import React, { useCallback, useEffect, useState } from 'react';
import { CButton, CContainer, CModal } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { useDispatch, useSelector } from 'react-redux';

import { CUSTOM_EXTERNAL_DATA_MODAL_STEPS } from '../../../../../../constants';
import Intro from './Intro';
import NameExternalData from './NameExternalData';
import { setCustomExternalDataModal } from '../../../../../../actions/subscriber';

export const CustomExternalDataContext = React.createContext({});

export const CustomExternalDataBody = ({ onBackBtnClicked, children, mainContentClassName = '' }) => {
    return (
        <CContainer className="main-container">
            <div className="d-flex align-items-center m-0 main-header">
                <CButton
                    className={`btn-back m-0`}
                    onClick={onBackBtnClicked}
                >
                    Back
                </CButton>
                <div className="hero-logo">
                    <CIcon icon="logo-dark" height={23} />
                </div>
            </div>
            <div className={`main-content ${mainContentClassName}`}>
                {children}
            </div>
        </CContainer>
    );
}

const CustomExternalDataModal = () => {
    const dispatch = useDispatch();
    const customExternalDataModal = useSelector((state) => state.subscriber.customExternalDataModal);
    const [currentStep, setCurrentStep] = useState(customExternalDataModal.initialStep || CUSTOM_EXTERNAL_DATA_MODAL_STEPS.INTRO);
    const showPopup = customExternalDataModal.show;

    const handleWhenHideAndShowPopup = () => {
        const popupShow = document.querySelector(".create-account-popup.custom-destination-modal .modal.show");

        if (showPopup) {
            setTimeout(() => {
                document.body.classList.add('no-scroll');
                if (popupShow) {
                    popupShow.classList.add('popup-transition');
                }
            }, 0);
        } else {
            document.body.classList.remove('no-scroll');
        }
    };

    useEffect(handleWhenHideAndShowPopup, [showPopup]);

    const getCurrentComponent = useCallback(() => {
        switch (currentStep) {
            case CUSTOM_EXTERNAL_DATA_MODAL_STEPS.INTRO:
                return <Intro />;
            case CUSTOM_EXTERNAL_DATA_MODAL_STEPS.NAME_EXTERNAL_DATA:
                return <NameExternalData />;
            default:
                return <></>;
        }
    }, [currentStep]);

    const closeModal = () => {
        dispatch(setCustomExternalDataModal({ show: false }));
    }

    const contextValue = {
        currentStep, setCurrentStep,
        closeModal
    };

    return (
        <div className="create-account-popup custom-destination-modal">
            <CustomExternalDataContext.Provider value={contextValue}>
                <CModal visible={showPopup} onClose={closeModal} backdrop="static" portal={false}>
                    <div className="modal-body">
                        {getCurrentComponent()}
                    </div>
                </CModal>
            </CustomExternalDataContext.Provider>
        </div>
    );
};

export default CustomExternalDataModal;
